import { render, staticRenderFns } from "./RenewInfo.vue?vue&type=template&id=48a7ea27&scoped=true"
import script from "./RenewInfo.vue?vue&type=script&lang=ts"
export * from "./RenewInfo.vue?vue&type=script&lang=ts"
import style0 from "./RenewInfo.vue?vue&type=style&index=0&id=48a7ea27&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a7ea27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48a7ea27')) {
      api.createRecord('48a7ea27', component.options)
    } else {
      api.reload('48a7ea27', component.options)
    }
    module.hot.accept("./RenewInfo.vue?vue&type=template&id=48a7ea27&scoped=true", function () {
      api.rerender('48a7ea27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/RenewInfo.vue"
export default component.exports